/*! @azure/msal-browser v3.18.0 2024-07-01 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isBridgeError(error) {
    return error.status !== undefined;
}

export { isBridgeError };
//# sourceMappingURL=BridgeError.mjs.map
